<div class="tw-pr-2 tw-border-b tw-border-primary/10 tw-flex tw-justify-between tw-items-center">
  <h2 class="!tw-px-5 !tw-py-4 tw-text-primary tw-font-bold tw-text-lg">AÑADIR OTROS DATOS</h2>

  <button mat-icon-button [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="tw-p-2 tw-pt-4 tw-border-b tw-border-primary/10">
  <app-form-field
    class="tw-w-56"
    [type]="'text'"
    [fieldControl]="form.controls['filter'] | asFormControl"
    [label]="'Filtrar'"
  >
  </app-form-field>

  <!-- Filtro avanzado -->
  <div class="tw-w-full">
    <app-advanced-filter-select
      class="[&_.label]:!tw-top-[-11px]"
      [options]="filterOptions"
      (onFilter)="applyFilters($event)"
    ></app-advanced-filter-select>
  </div>
</div>

<mat-dialog-content class="tw-flex tw-flex-col tw-gap-4 !tw-overflow-auto !tw-p-2">
  <!-- Tabla con scroll -->
  <div class="tw-w-full tw-h-[calc(100%-0.5rem)] tw-overflow-y-auto tw-rounded-lg">
    <table
      mat-table
      [dataSource]="dataSource"
      class="!tw-bg-white tw-rounded-lg"
    >

      <!-- Columna de selección -->
      <ng-container matColumnDef="select">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none !tw-rounded-l-lg !tw-w-12"
        >
          <mat-checkbox
            (change)="toggleAll($event)"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            color="primary"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1 !tw-text-center">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="toggleSelection(element)"
            [checked]="isSelected(element)"
            color="primary"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- CIPNA / Paciente -->
      <ng-container matColumnDef="FIPACIENTE">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none !tw-w-64"
        >
          CIPNA
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.FIPACIENTE }}
        </td>
      </ng-container>

      <ng-container matColumnDef="NombrePaciente">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none !tw-w-64"
        >
          Paciente
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.NombrePaciente }}
        </td>
      </ng-container>

      <!-- CIE -->
      <ng-container matColumnDef="FICIAP">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          CIE
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1 tw-font-bold">
          {{ element.FICIAP }}
        </td>
      </ng-container>

      <!-- Medicamento -->
      <ng-container matColumnDef="FIMEDICA">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none !tw-w-64"
        >
          CN
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.FIMEDICA }}
        </td>
      </ng-container>

      <ng-container matColumnDef="NombreMedicamento">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none !tw-rounded-r-lg !tw-w-64"
        >
          Medicamento
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.NombreMedicamento }}
        </td>
      </ng-container>

      <!-- Precio -->
      <ng-container matColumnDef="FIMPORTEC">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          Precio
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.FIMPORTEC | number:'1.2-2' }}
        </td>
      </ng-container>

      <!-- U/envase -->
      <ng-container matColumnDef="FIUNIENV">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          U/envase
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.FIUNIENV }}
        </td>
      </ng-container>

      <!-- U/dia consumidas -->
      <ng-container matColumnDef="FIUNIDIA">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          U/dia consumidas
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.FIUNIDIA }}
        </td>
      </ng-container>

      <!-- Dias tratamiento -->
      <ng-container matColumnDef="FIDIAS">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          Dias tratamiento
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.FIDIAS }}
        </td>
      </ng-container>

      <!-- IVA -->
      <ng-container matColumnDef="IVA">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          IVA
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.IVA }}
        </td>
      </ng-container>

      <!-- Importe facturado -->
      <ng-container matColumnDef="FIMPORTEF">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          Importe facturado
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.FIMPORTEF | number:'1.2-2' }}
        </td>
      </ng-container>

      <!-- Tipo compra -->
      <ng-container matColumnDef="TIPOCOMPRA">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none !tw-w-44 !tw-shrink-0"
        >
          Tipo compra
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
          {{ element.TIPOCOMPRA == 1 ? 'Lab' : 'Distr' }}
        </td>
      </ng-container>

      <!-- Marcadores de filtro -->
      <ng-container matColumnDef="flags">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!tw-text-white !tw-bg-primary !tw-border-none"
        >
          Características
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-text-xs !tw-p-1">
          <div class="tw-flex tw-flex-wrap tw-gap-1">
            <span *ngIf="element.AtHome" class="tw-px-2 tw-py-0.5 tw-bg-blue-100 tw-text-blue-800 tw-rounded">AtHome</span>
            <span *ngIf="element.ForcedPayment" class="tw-px-2 tw-py-0.5 tw-bg-orange-100 tw-text-orange-800 tw-rounded">ForcedPayment</span>
            <span *ngIf="element.IsPrivate" class="tw-px-2 tw-py-0.5 tw-bg-purple-100 tw-text-purple-800 tw-rounded">IsPrivate</span>
            <span *ngIf="element.MutuasMuface" class="tw-px-2 tw-py-0.5 tw-bg-green-100 tw-text-green-800 tw-rounded">MutuasMuface</span>
            <span *ngIf="element.OutsidePharma" class="tw-px-2 tw-py-0.5 tw-bg-red-100 tw-text-red-800 tw-rounded">OutsidePharma</span>
            <span *ngIf="!element.RecurrencePattern" class="tw-px-2 tw-py-0.5 tw-bg-yellow-100 tw-text-yellow-800 tw-rounded">Sin Recurrencia</span>
            <span *ngIf="!element.PayMed" class="tw-px-2 tw-py-0.5 tw-bg-gray-100 tw-text-gray-800 tw-rounded">Sin PayMed</span>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="!tw-h-10 tw-text-xs !tw-bg-transparent"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        class="hover:!tw-bg-primary/5 tw-cursor-pointer"
        (click)="toggleSelection(row)"
      ></tr>

      <!-- Fila cuando no hay resultados -->
      <tr
        *matNoDataRow
        class="hover:!tw-bg-transparent"
      >
        <td
          [attr.colspan]="displayedColumns.length"
          class="!tw-text-center !tw-py-8 !tw-text-gray-500 !tw-border-none"
        >
          <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
            <mat-icon class="!tw-w-[48px] !tw-h-[48px] !tw-text-[48px] tw-flex tw-items-center tw-justify-center tw-text-gray-400">filter_alt_off</mat-icon>
            <span class="tw-text-base tw-font-medium">No hay datos con los filtros seleccionados</span>
            <span class="tw-text-sm tw-text-gray-400">Intenta ajustar los filtros de búsqueda</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="!tw-p-2 !tw-border-t !tw-border-primary/10">
  <button mat-button (click)="onCancel()" class="!tw-text-gray-600">
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="selectedItems.size === 0"
  >
    Añadir {{ selectedItems.size }} elemento{{ selectedItems.size !== 1 ? 's' : '' }}
  </button>
</mat-dialog-actions>
